export default __webpack_public_path__ + "static/SRUS P450 - Especification Del Producto y Datos Técnicos-1575047d10af06165bdd6280a71196c2.pdf";